// Converts text to a valid URI fragment identifier per RFC 3986.
// Allows only characters that are valid in URI fragments according to the spec:
// https://datatracker.ietf.org/doc/html/rfc3986#section-3.5
export const getAnchorLink = (text: string) => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 \-._~!$&'()*+,;=:@/?]/g, '')
    .replace(/ /g, '-');
};
